import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import rootReducer from './reducers';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
// Data
import inquiryTypes from './data/inquiryTypes';
import targetSystems from './data/targetSystems';

export let history = createBrowserHistory();

let initialState = {
    inquiryTypes,
    targetSystems
};
let enhancers = [];
let middleware = [
    thunk,
    routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
    let devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension());
    }
}

let composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

let store = createStore(
    rootReducer,
    initialState,
    composedEnhancers
);

export default store;